import Fetch from ".";

export const createMyZapInstance = async (body) => {
    const data = new FormData();
    for (const key in body) {
        if (Array.isArray(body[key])) {
            for (const value of body[key]) {
                data.append(key+"[]", value);
            }
            continue
        }
        data.set(key, body[key]);
    }

    return Fetch(
        '/myzap-instance/',
        {
            method: 'POST',
            body: data,
        },
    )
}

export const updateMyZapInstance = (id, body) => {
    delete body['createdAt']
    delete body['updatedAt']
    delete body['deletedAt']
    delete body['id']

    return Fetch(
        '/myzap-instance/' + id,
        {
            method: 'PUT',
            body: JSON.stringify(body),
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const deleteMyZapInstance = (id) => {
    return Fetch(
        '/myzap-instance/' + id,
        {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json",
            }
        },
    )
}

export const getMyZapById = async (id) => {
    if (!id)
        return Promise.reject("failed to read id");

    return Fetch("/myzap-instance/" + id)
}

export const getMyZapInstance = async ({ assistantID }) => {
    if (!assistantID)
        return Promise.reject("failed to read id");

    return Fetch("/myzap-instance/?assistantID=" + assistantID)
}

export const getMyZapInstances = async () => {
    return Fetch("/myzap-instance")
}
